<template>
  <div id="service-2" class="service-section pt-60">
    <div class="container">
      <!-- Başlık -->
      <div class="row justify-content-center">
        <div class="col-xl-8 col-lg-8">
          <div class="section-title text-up">
            <h2>{{ vars.titleText }}</h2>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 text-start">
          <p>{{ vars.descriptionText }}</p>
        </div>
      </div>

      <!-- Accordion -->
      <div class="row">
        <div class="col-xl-12">
          <div class="cp-custom-accordion">
            <div class="accordions">
              <div
                class="accordion-items"
                v-for="(service, index) in services"
                :key="service.id ?? index"
              >
                <h2 class="accordion-header">
                  <button
                    class="accordion-buttons"
                    type="button"
                    :aria-expanded="openIndex === index"
                    @click="toggle(index)"
                  >
                    <span style="color: grey;">{{ String(index + 1).padStart(2, '0') }}</span>
                    <h3 class="m-0 ms-2">{{ service.title }}</h3>
                  </button>
                </h2>

                <!-- SADECE SEÇİLEN ÖĞE RENDER EDİLİR -->
                <div class="accordion-panel" v-if="openIndex === index">
                  <div class="accordion-body">
                    <img :src="service.photo" alt="" />
                    <p>{{ service.description }}</p>
                  </div>
                </div>

              </div> <!-- .accordion-items -->
            </div> <!-- .accordions -->
          </div> <!-- .cp-custom-accordion -->
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  mixins: [ComponentMixin],
  data() {
    return {
      openIndex: -1 as number, // -1 = hiçbiri açık
    };
  },
  computed: {
    services() {
      return this.groupedVariables.services || [];
    },
  },
  methods: {
    toggle(idx: number) {
      this.openIndex = this.openIndex === idx ? -1 : idx;
    },
  },
});
</script>

<style scoped>
/* Bootstrap'ın global collapse kuralları karışmasın diye minimum stiller */
.accordion-panel { overflow: hidden; }
</style>
